import './axios';
import './fontawesome';
import './vuelidate';
import './wait';
import './api_query';
import './moment';
import './cookie';
import './uiplugins';
